import { TechemTheme } from '@techem/techem-theme';
import { styled } from 'baseui';
import AnimatedExpandingView from 'presentation/components/AnimatedExpandingView';
import React, { useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';
import Chevron from './Chevron';

const AccordionView = styled('div', (props: Omit<any, '$theme'>) => ({
  borderBottom: props.underlined ? '1px solid ' + TechemTheme.colors.mono300 : 'inherit'
}));

interface Props {
  title: string;
  content: any;
  last?: boolean;
}

const Accordion: React.FC<Props> = ({ title, content, last }) => {
  const [active, setActive] = useState<string>('');
  const [isOpen, setOpen] = useState<boolean>(false);
  const [chevronClassNames, setChevronClassNames] = useState<string>('accordion__icon');

  const isMobile = useMediaQuery('(max-width: 767px)');

  const contentRef = useRef<HTMLDivElement>(null!);

  const toggleAccordion = () => {
    setActive(active === '' ? 'active' : '');
    setOpen(!isOpen);
    setChevronClassNames(active === 'active' ? 'accordion__icon' : 'accordion__icon rotate');
  };

  return (
    <AccordionView underlined={!last} className={`accordion__section py-3 mb-0 ${active}`}>
      <button className="accordion py-0" onClick={toggleAccordion}>
        <Chevron className={chevronClassNames} />

        {isMobile ? (
          <h6 className="accordion__title ps-3 fw-bold fs-6">
            <Trans i18nKey={title} />
          </h6>
        ) : (
          <span className="accordion__title ps-3 fw-bold fs-5">
            <Trans i18nKey={title} />
          </span>
        )}
      </button>
      <div
        ref={contentRef}
        className={`accordion__content accordion-collapse ${isOpen ? 'd-block' : 'd-none'}`}
      >
        <AnimatedExpandingView>
          {active ? (
            <div
              className={`accordion__text copy mx-2 ps-5 text-break pb-0 mt-3 ${
                isMobile ? 'fs-6' : ''
              }`}
            >
              <Trans i18nKey={content} />
            </div>
          ) : (
            <></>
          )}
        </AnimatedExpandingView>
      </div>
    </AccordionView>
  );
};

export default Accordion;
